__webpack_require__.p = "/mi-assets/mi-static/mi-chat-renderer/web-rel-26.9.2-57d475a-16353/_next/";